import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { Check, Heart, Home, DollarSign, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const points = [{
    icon: <DollarSign className="w-5 h-5 text-white" data-id="element-181" />,
    text: 'Querés generar ingresos desde casa'
  }, {
    icon: <Sparkles className="w-5 h-5 text-white" data-id="element-182" />,
    text: 'No tenés experiencia en manicura pero te interesa empezar'
  }, {
    icon: <Heart className="w-5 h-5 text-white" data-id="element-183" />,
    text: 'Sentís que necesitás un cambio económico'
  }, {
    icon: <Home className="w-5 h-5 text-white" data-id="element-184" />,
    text: 'Querés tener algo propio y dejar de depender de otros'
  }];
  return <section className="py-20 bg-rose-50 relative" data-id="element-185">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="text-center mb-12" data-id="element-187">
          <motion.span className="text-rose-600 font-bold tracking-wider uppercase text-sm mb-4 block" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-188">
            La Solución
          </motion.span>
          <SectionHeading title="Por eso creamos el ebook:" subtitle="“Empezá y ganá”" data-id="element-189" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-190">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-191">
            <h3 className="text-2xl font-bold mb-6 font-playfair" data-id="element-192">
              Este producto es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-193">
              {points.map((point, index) => <motion.li key={index} className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border border-rose-100" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.4
            }} data-id="element-194">
                  <div className="bg-rose-500 p-2 rounded-lg shrink-0 shadow-md shadow-rose-500/20" data-id="element-195">
                    {point.icon}
                  </div>
                  <span className="text-dark font-medium" data-id="element-196">{point.text}</span>
                </motion.li>)}
            </ul>

            <div className="mt-8 p-6 bg-rose-100 rounded-2xl border border-rose-200" data-id="element-197">
              <p className="text-rose-900 font-medium text-lg text-center" data-id="element-198">
                Todo pensado para ayudarte a aprender rápido, ganar confianza y
                generar ingresos desde tu propio hogar.
              </p>
            </div>
          </motion.div>

          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-199">
            {/* Abstract representation of the ebook/success */}
            <div className="aspect-square rounded-full bg-gradient-to-tr from-rose-200 to-rose-400 p-8 relative flex items-center justify-center shadow-soft" data-id="element-200">
              <div className="absolute inset-0 bg-white/40 rounded-full backdrop-blur-sm m-8 border border-white/60 shadow-inner" data-id="element-201"></div>
              <div className="relative z-10 text-center" data-id="element-202">
                <div className="bg-white w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl" data-id="element-203">
                  <Sparkles className="w-10 h-10 text-gold-500" data-id="element-204" />
                </div>
                <h4 className="font-playfair text-3xl font-bold text-rose-900 mb-2" data-id="element-205">
                  Empezá y Ganá
                </h4>
                <p className="text-rose-800 font-medium" data-id="element-206">Tu camino al éxito</p>
              </div>

              {/* Decorative floating elements */}
              <motion.div className="absolute top-10 right-10 bg-white p-3 rounded-full shadow-lg" animate={{
              y: [0, -15, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-207">
                <DollarSign className="w-6 h-6 text-green-500" data-id="element-208" />
              </motion.div>
              <motion.div className="absolute bottom-10 left-10 bg-white p-3 rounded-full shadow-lg" animate={{
              y: [0, 15, 0]
            }} transition={{
              duration: 3.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 1
            }} data-id="element-209">
                <Heart className="w-6 h-6 text-rose-500" data-id="element-210" />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}